import { useMemo } from 'react'
import type { IDetailCellRendererParams } from 'ag-grid-community'
import { ColDefBuilder } from './columnDefaults'
import { BolBaseTable } from './BolBaseTable'
import { formatters } from '@/utils/intl/dateTimeFormatters'
import type { components } from '@/types/api/v1'

type Row = components['schemas']['bol__schema__BolResponse'] & { date_local?: string }
type RowDetails = Row['details'][0]

const detailColumns = new ColDefBuilder<RowDetails>({
  suppressMenu: true,
  suppressMovable: true,
  sortable: false,
  enableRowGroup: false,
})
  .defineColumn('product', { headerName: 'Product Name' })
  .defineColumn('supplier', { headerName: 'Supplier' })
  .defineColumn('net_volume', { headerName: 'Net QTY', maxWidth: 130 })
  .defineColumn('gross_volume', { headerName: 'Gross QTY', maxWidth: 130 }).columns

const parentColumns = new ColDefBuilder<Row>({
  suppressMenu: true,
  suppressMovable: true,
  sortable: false,
  enableRowGroup: false,
})
  .defineColumn('details.length', {
    headerName: 'Details',
    cellRenderer: 'agGroupCellRenderer',
    valueFormatter: () => '',
    maxWidth: 80,
  })
  .defineColumn('bol_number', {
    headerName: 'BOL #',
    maxWidth: 95,
  })
  .defineColumn('terminal', { headerName: 'Terminal/Origin' })
  .defineColumn('date', {
    headerName: 'Date/Time',
    maxWidth: 155,
    valueGetter: ({ data }) => (data?.date ? formatters.DATE_TIME(data?.date, data?.date_local, true) : undefined),
  }).columns

type BolObjectDetailsProps = {
  title?: string
  isLoading?: boolean
  data?: Gravitate.ShortBol
}
export const BolObjectDetails = ({ title = 'Current BOL', isLoading, data }: BolObjectDetailsProps) => {
  const detailCellRendererParams = useMemo<
    Partial<IDetailCellRendererParams<Gravitate.ShortBol, Gravitate.ShortBolDetails>>
  >(
    () => ({
      detailGridOptions: {
        columnDefs: detailColumns,
      },
    }),
    []
  )
  const rowData = useMemo(() => (data ? [data] : []), [data])
  return (
    <BolBaseTable
      controlBarProps={{
        title,
        customSearchBar: <></>,
      }}
      columnDefs={parentColumns}
      detailCellRendererParams={detailCellRendererParams}
      rowData={rowData}
      loading={isLoading}
      agPropOverrides={{
        getRowId: (p) => p.data.id,
        suppressRowClickSelection: true,
      }}
    />
  )
}
